import React from 'react';
import SimpleContent from 'js/components/Common/SimpleContent/SimpleContent';
import CookiePolicyPopup from 'js/components/Common/CookiePolicyPopup/CookiePolicyPopup';

const PolicyTemplate = ({ pageId }) => (
	<main className="templatePolicy">
		<SimpleContent pageId={pageId}/>
		<CookiePolicyPopup/>
	</main>
);

export default PolicyTemplate;
